import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentAnalysisDetails = ({
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.CLASSIC_RE_ENROLL_jsx",
      elements: {
        ObjectNameLabel,
        b: 'b'
      },
      options: {
        portalId: selectedEnrollment.portalId,
        objectTypeId: selectedEnrollment.objectTypeId,
        objectId: selectedEnrollment.objectId,
        showId: getIsInternal()
      }
    })
  });
};
export default ClassicReenrollmentAnalysisDetails;